import React from 'react';
import {any, array, bool, func, instanceOf, string} from 'prop-types';
import pick from 'lodash/pick';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import defaultProps from 'recompose/defaultProps';
import setPropTypes from 'recompose/setPropTypes';
import setDisplayName from 'recompose/setDisplayName';
import withStateHandlers from 'recompose/withStateHandlers';
import {FormattedMessage} from 'react-intl';
import moment from 'moment-timezone';
import {DateTimePicker} from 'react-widgets';
import {Dropdown, Grid, Icon, Label} from 'semantic-ui-react';
import momentLocalizer from 'react-widgets-moment';
import BasicModal from 'components/common/BasicModal';
import {isNoU} from "../../utils/DBUtils";

const mapStateToProps = state => ({
  isOpen: state.dateRange.isOpen
});

const initialState = props => ({
  lowerBound: props.defaultLowerBound || null,
  upperBound: props.defaultUpperBound || null,
  filterType: props.defaultFilterType || null
});

export default compose(
  setDisplayName('DateRangeModal'),
  setPropTypes({
    isOpen: bool,
    close: func.isRequired,
    submit: func.isRequired,
    clear: func.isRequired,
    filterTypes: array,
    lowerBoundLabelKey: string,
    upperBoundLabelKey: string,
    defaultLowerBound: instanceOf(Date),
    defaultUpperBound: instanceOf(Date),
    defaultFilterType: any
  }),
  defaultProps({
    filterTypes: [],
    lowerBoundLabelKey: 'dateRange.modal.label.lowerBound',
    upperBoundLabelKey: 'dateRange.modal.label.upperBound'
  }),
  connect(mapStateToProps),
  withStateHandlers(initialState, {
    setLowerBound: (state, props) => date => ({lowerBound: date}),
    setUpperBound: (state, props) => date => ({upperBound: date}),
    setFilterType: (state, props) => (event, data) => ({filterType: data.value})
  }),
  withProps(props => {
    const hasFilterTypes = props.filterTypes.length > 0;
    const currentFilterType = props.filterType || props.defaultFilterType;

    const bothSelected = !isNoU(props.lowerBound) && !isNoU(props.upperBound);

    const lowerBound = moment(props.lowerBound);
    const upperBound = moment(props.upperBound);
    const upperAfterLower = upperBound.isAfter(lowerBound);

    const fields = ['lowerBound', 'upperBound'].concat(hasFilterTypes ? 'filterType' : []);
    const canSubmit = fields.map(field => props[field]).every(Boolean) && upperAfterLower;
    const handleSubmit = () => props.submit(pick(props, fields));

    return {
      bothSelected,
      upperAfterLower,
      hasFilterTypes,
      currentFilterType,
      actions: [{
        label: <FormattedMessage id='cancel' />,
        action: props.close,
        displayType: 'menu-item'
      }, {
        label: <FormattedMessage id='clear' />,
        action: props.clear,
        displayType: 'button',
        secondaryCheck: true
      }, {
        label: <FormattedMessage id='confirm' />,
        action: handleSubmit,
        displayType: 'button',
        primaryCheck: true,
        isDisabled: !canSubmit
      }]
    };
  }),
  lifecycle({
    componentWillMount() {
      moment.locale('en');
      momentLocalizer();
    }
  })
)(props => (
  <BasicModal
    dimmer={true}
    modalSize='small'
    scrolling={false}
    open={props.isOpen}
    onClose={props.close}
    actions={props.actions}
    header={<FormattedMessage id='dateRange.modal.header' />}
    specialType='primary-modal date-range-modal fadeInUp animResponse'>
    <Grid className='date-range-controls'>
      {props.hasFilterTypes && (
        <Grid.Row>
          <Grid.Column width={16}>
            <Grid.Row>
              <Label basic className='db-field-label'>
                <Icon name='asterisk' className='inline' />
                <FormattedMessage id='dateRange.modal.label.filterType' />
              </Label>
            </Grid.Row>
            <Grid.Row>
              <Dropdown
                selection={true}
                openOnFocus={false}
                selectOnBlur={false}
                closeOnChange={true}
                selectOnNavigation={false}
                options={props.filterTypes}
                onChange={props.setFilterType}
                value={props.currentFilterType}
                className='date-range-filter-types'
                text={<FormattedMessage id={`dateRange.filterType.${props.currentFilterType}`} />} />
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <Grid.Column width={8}>
          <Grid.Row>
            <Label basic className='db-field-label'>
              <Icon name='asterisk' className='inline' />
              <FormattedMessage id={props.lowerBoundLabelKey} />
            </Label>
          </Grid.Row>
          <Grid.Row>
            <DateTimePicker
              time={false}
              value={props.lowerBound}
              onChange={props.setLowerBound} />
          </Grid.Row>
        </Grid.Column>
        <Grid.Column width={8}>
          <Grid.Row>
            <Label basic className='db-field-label'>
              <Icon name='asterisk' className='inline' />
              <FormattedMessage id={props.upperBoundLabelKey} />
            </Label>
          </Grid.Row>
          <Grid.Row>
            <DateTimePicker
              time={false}
              value={props.upperBound}
              onChange={props.setUpperBound} />
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
      {props.upperAfterLower || !props.bothSelected ? "" : (
          <Grid.Row>
            <Label basic className="db-error-label">
              <FormattedMessage id={`errors.dateRange.upperBeforeLower`}/>&nbsp;
            </Label>
          </Grid.Row>
      )}
    </Grid>
  </BasicModal>
));



// WEBPACK FOOTER //
// ./public/components/DateRange/DateRangeModal.jsx